module.exports = __webpack_public_path__ + "img/_empty_states_archive.7d854745.svg";